<template>
  <!-- 头部字典项搜索 收起、展开 -->
  <!-- 搜索详情 -->
  <div class="cmp-search-dict">
    <!-- <div class="search-head">
      <el-input
        class="mb-10"
        style="width:350px;"
        placeholder="以藏品编号/一普编号/藏品名称关键字搜索"
        @keyup.enter.native="searchTag(listQuery.key,0,listQuery.key)"
        v-model="listQuery.key"
      >
        <i
          slot="suffix"
          class="el-icon-search g-pointer"
          @click="searchTag(listQuery.key,0,listQuery.key)"
        ></i>
      </el-input>
      <el-button class="ml-20" @click="restTag(dynamicTags)">重置</el-button>
      <span @click="toggleShowHead" ref="spanOne" class="switch g-pointer">
        {{showHead ? '收起' : '更多'}}
        <i :class="showHead?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
      </span>
    </div> -->

    <div v-if="showHead">
      <!-- <div class="sch sch-top">
        <div class="total-type">全部结果 :</div>
        <div>
          <el-tag
            :key="item.type"
            v-for="item in headTagChoosed"
            closable
            :disable-transitions="false"
            @close="handleClose(item)"
            ref="tag"
            class="tag mb-10"
          >{{item.name}}</el-tag>
        </div>
      </div> -->

      

      <!-- 博物馆/革命文物 -->
      <div class="sch">
        <div class="sch-type" v-if="pageType === '1'">类型 :</div>
        <div class="sch-type" v-if="pageType === '2'">藏品分类 :</div>
        <div class="sch-content" :class="{'fix-height': showTagLine}">
          <span
            v-for="(item,index) in searchTypeList"
            :key="index"
            @click="searchTag(item.dictCode,1,item.dictName)"
            :class="{'blue': listQuery.musenumType === item.dictCode}"
          >{{item.dictName}}</span>
          <span class="switch g-pointer" @click="showTagLine=!showTagLine" v-if="pageType === '2'">
            {{showTagLine ? '更多' : '收起'}}
            <i
              :class="showTagLine?'el-icon-arrow-right':'el-icon-arrow-down'"
            ></i>
          </span>
        </div>
      </div>

      <!-- 革命文物 -->
      <!-- <div class="sch" v-if="pageType === '2'">
        <div class="sch-type">藏品分类 :</div>
        <div class="sch-content" :class="{'fix-height': showTagLine}">
          <span
            v-for="(item,index) in searchTypeList"
            :key="index"
            @click="searchTag(item.dictCode,1,item.dictName)"
            :class="{'blue': listQuery.type === item.dictCode}"
          >{{item.dictName}}</span>
          <span class="switch g-pointer" @click="showTagLine=!showTagLine">
            {{showTagLine ? '更多' : '收起'}}
            <i
              :class="showTagLine?'el-icon-arrow-right':'el-icon-arrow-down'"
            ></i>
          </span>
        </div>
      </div> -->

      <div class="sch">
        <div class="sch-type">城市 :</div>
        <div class="sch-content" :class="{'fix-height': showLeveLine}">
          <span
            v-for="(item,index) in searchLevelList"
            :key="index"
            @click="searchTag(item.dictCode,2,item.dictName)"
            :class="{'blue': listQuery.city === item.dictCode}"
          >{{item.dictName}}</span>

          <span class="switch g-pointer" @click="showLeveLine=!showLeveLine">
            {{showLeveLine ? '更多' : '收起'}}
            <i
              :class="showLeveLine?'el-icon-arrow-right':'el-icon-arrow-down'"
            ></i>
          </span>
        </div>
      </div>

      <div class="sch" v-if="pageType === '2'">
        <div class="sch-type">所属年代 :</div>
        <div class="sch-content" :class="{'fix-height': showYearLine}">
          <span
            v-for="(item,index) in searchYearList"
            :key="index"
            @click="searchTag(item.dictCode,3,item.dictName)"
            :class="{'blue': listQuery.year === item.dictCode}"
          >{{item.dictName}}</span>

          <!-- <span class="switch g-pointer" @click="showYearLine=!showYearLine">
            {{showYearLine ? '更多' : '收起'}}
            <i
              :class="showYearLine?'el-icon-arrow-right':'el-icon-arrow-down'"
            ></i>
          </span> -->
        </div>
      </div>

      <!-- <div class="sch-last">
        <div class="sch-type">高级选项 :</div>
        <div class="type-content">
          <el-form ref="form" :model="listQuery" label-width inline>
            <el-row :gutter="10">
              <el-col :span="4">
                <el-form-item>
                  <el-cascader
                    ref="myCascader"
                    v-model="listQuery.collectTexture"
                    placeholder="质地类别"
                    :props="{ value: 'dictCode', label: 'dictName',checkStrictly: true }"
                    :options="collectTextureList"
                    :show-all-levels="false"
                    @visible-change="clickOption(4,listQuery.collectTexture,collectTextureList, $event)"
                  ></el-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="listQuery.collectDisablity"
                    placeholder="完残程度"
                    @change="clickOption(5,listQuery.collectDisablity,collectDisablity)"
                  >
                    <el-option
                      v-for="item in collectDisablity"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4" v-if="!$route.query.state && pageType!=='1'">
                <el-form-item>
                  <el-select
                    v-if="pageType!=='5'"
                    v-model="listQuery.accountState"
                    placeholder="建账状态"
                    @change="clickOption(6,listQuery.accountState,accountState)"
                  >
                    <el-option
                      v-for="item in accountState"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="pageType==='5'"
                    v-model="listQuery.enterStorgeState"
                    placeholder="入库状态"
                    @change="clickOption(6,listQuery.enterStorgeState,enterStorgeStateList)"
                  >
                    <el-option
                      v-for="item in enterStorgeStateList"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="listQuery.source"
                    placeholder="文物来源"
                    @change="clickOption(7,listQuery.source,source)"
                  >
                    <el-option
                      v-for="item in source"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="listQuery.qualityRange"
                    placeholder="质量范围"
                    @change="clickOption(8,listQuery.qualityRange,massRangeList)"
                  >
                    <el-option
                      v-for="item in massRangeList"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="listQuery.enterCollectRange"
                    placeholder="入藏时间范围"
                    @change="clickOption(9,listQuery.enterCollectRange,timeList)"
                  >
                    <el-option
                      v-for="item in timeList"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4" v-if="pageType==='5'">
                <el-form-item>
                  <el-select
                    v-model="listQuery.storgeId"
                    placeholder="库房名称"
                    @change="clickOption(10,listQuery.storgeId,storgeNameList)"
                  >
                    <el-option
                      v-for="item in storgeNameList"
                      :key="item.storgeId"
                      :label="item.storgeName"
                      :value="item.storgeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div> -->
    </div>


    <div class="sort-box">
      <!-- <div class="sort-btns">
        <a class="g-btn-text" :class="{'g-btn-border':item.value===sortActive}" v-for="item in sortArr" :key="item.value" @click="handleSort(item)">{{item.name}}</a>
      </div> -->
      <el-input clearable v-model="listQuery.key" placeholder="输入关键字" @keyup.enter.native="getParams" style="width:400px;">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    // 1:博物馆  2：革命文物
    pageType: {
      type: String,
      default: ''
    },
    sortArr: {
      type: Array,
      default() {
        return [
          {
            name: '默认排序',
            value: '1'
          },
          {
            name: '距离优先',
            value: '2'
          }
        ]
      }
    }
  },
  // computed: {
  //   dictName() {
  //     let arr = []

  //     return arr
  //   }
  // },
  watch: {
    $route() {
      this.restTag()
    }
  },
  data() {
    return {
      showHead: true, // 是否显示头部
      // 定义搜索下拉框状态值
      collectTextureList: [], // 质地
      source: [], // 来源
      accountState: [
        { dictName: '未建账', dictCode: '0' },
        { dictName: '已建账', dictCode: '1' }
      ],
      enterStorgeStateList: [
        { dictName: '未入库', dictCode: '0' },
        { dictName: '已入库', dictCode: '1' }
      ],
      collectDisablity: [], // 完残程度
      collectStatus: [], // 藏品状态
      massRangeList: [], // 质量范围
      timeList: [], // 入藏时间范围
      storgeNameList: [], // 库房名称

      dynamicTags: [],

      headTagChoosed: [], // 头部已选中标签
      searchTypeList: [], // 分类
      showTagLine: true, // 分类显示一行
      searchYearList: [], // 年代
      showYearLine: true, // 年代显示一行
      searchLevelList: [], // 级别
      showLeveLine: true,     // 级别显示一行
      listQuery: {
        key: '', // 关键字
        musenumType: '', //	博物馆类型
        city: '',

        year: '', // 所属年代
      },

      sortActive: ''
    }
  },
  methods: {
    init() {
      this.getCityData()
      if(this.pageType === '1') {
        this.getMuseumTypeData()
      } else if(this.pageType === '2') {
        this.getRevolutionSelData()
      }

      this.sortActive = this.sortArr[0].value
    },
    // 切换显示头部
    toggleShowHead() {
      this.showHead = !this.showHead
    },
    searchTag(code, type, name) {
      this.setHeadChoosed(type, code, name)
      if (type === 1) {
        // 博物馆类型
        this.listQuery.musenumType = code
      } else if (type === 2) {
        // 城市
        this.listQuery.city = code
      } else if (type === 3) {
        // 所属年代
        this.listQuery.year = code
      }
      this.getParams()
    },
    handleSort(item) {
      this.sortActive = item.value
      console.log(111)
    },
    // 获取博物馆类型
    getMuseumTypeData() {
      this.$http
        .post('/Guide/museumType.do', {})
        .then(res => {
          res.data.forEach(item => {
            item.dictName = item.category_name
            item.dictCode = item.id
          })
          
          this.searchTypeList = [{dictName: '全部', dictCode: ''}].concat(res.data)
        })
    },
    // 获取城市
    getCityData() {
      this.$http
        .post('/Guide/countMap.do', {})
        .then(res => {
          res.data.forEach(item => {
            item.dictName = item.name
            item.dictCode = item.id
          })
          this.searchLevelList = [{dictName: '全部', dictCode: ''}].concat(res.data)
        })
    },
    // 革命文物查询条件
    getRevolutionSelData() {
      this.$http
        .get('/moduleCollectDict/getSelectDataByArr.do', {
          arr: ['gmww_sjduan', 'org_type']
        })
        .then(res => {
          let arr = [{dictName: '全部', dictCode: ''}]
          
          this.searchTypeList = arr.concat(res.data.org_type) // 藏品分类
          this.searchYearList = arr.concat(res.data.gmww_sjduan) // 所属年代
        })
    },
    // // 获取下拉状态多选择值
    // initSelect() {
    //   this.$http
    //     .post('/collectDict/getSelectDataByArr', {
    //       arr: [
    //         'collection_come_from',
    //         'degree_disability',
    //         'mass_range',
    //         'time_frame',
    //         'manage_collection_status'
    //       ]
    //     })
    //     .then(res => {
    //       if (res.success) {
    //         var state = res.result
    //         this.source = state['collection_come_from']
    //         this.collectDisablity = state['degree_disability']
    //         this.massRangeList = state['mass_range']
    //         this.timeList = state['time_frame']
    //         this.collectStatus = state['manage_collection_status']
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },
    // // 查询藏品质地
    // getCollectTexture() {
    //   this.$http
    //     .post('/collectDict/getCascadeSelectDataByDictType', {
    //       dictType: 'collection_texture'
    //     })
    //     .then(res => {
    //       if (res.success) {
    //         this.collectTextureList = res.result
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },
    // 搜索项选中
    clickOption(type = '', value = '', chooseList = '', isClose) {
      let selectStr = '' // 选中字典项的名称
      if (type === 10) {
        // 库房
        selectStr = chooseList.filter(item => item.storgeId === value)[0]
          .storgeName
      } else if (type === 4) {
        if (!isClose && this.$refs.myCascader.getCheckedNodes().length) {
          // 质地类别
          let labelsArr = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
          selectStr = labelsArr[labelsArr.length - 1]
        } else {
          return
        }
      } else {
        // 字典项
        selectStr = chooseList.filter(item => item.dictCode === value)[0]
          .dictName
      }
      if (type && value && chooseList) {
        this.setHeadChoosed(type, value, selectStr)
      }
      this.getParams()
    },
    // 同步标签
    setHeadChoosed(type, value, name) {
      if (!this.headTagChoosed.some(item => item.type === type)) {
        if (name) {
          this.headTagChoosed.push({ type, value, name })
        }
      } else {
        this.headTagChoosed.forEach(item => {
          if (item.type === type) {
            if (!name) {
              this.headTagChoosed.splice(this.headTagChoosed.indexOf(item), 1)
            } else {
              item.value = value
              item.name = name
            }
          }
        })
      }
    },
    getParams() {
      this.$emit('getParams', {
        ...this.listQuery
      })
    },
    // tag标签删除方法
    handleClose(tag) {
      switch (tag.type) {
        case 0:
          this.listQuery.key = ''
          break
        case 1:
          this.listQuery.musenumType = ''
          break
        case 2:
          this.listQuery.city = ''
          break
        case 3:
          this.listQuery.year = ''
          break
      }
      this.headTagChoosed.splice(this.headTagChoosed.indexOf(tag), 1)
      this.getParams()
    },
    // 重置标签
    restTag() {
      this.headTagChoosed = []
      this.listQuery = {
        key: '', //	藏品名称

        musenumType: '',
        
        year: '', //	所属年代
        city: '', //	城市
      }
      this.getMuseumTypeData()
      // this.getCollectYearData()
      this.getCityData()
      this.getParams()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.cmp-search-dict {
  border-radius: 4px;
  // padding: 30px 30px 10px 30px;
  // background: #fff;
  .search-head {
    position: relative;
    .switch {
      position: absolute;
      right: 0;
      top: 7px;
      font-size: 14px;
      line-height: 30px;
      color: $primary;
    }
  }
  .el-button.reset {
    width: auto !important;
    font-size: 14px;
  }
}


.sch {
  position: relative;
  display: flex;
  padding: 15px 60px 15px 0;
  font-size: 16px;
  // background-color: #fff;
  .sch-type {
    width: 100px;
    height: 40px;
    line-height: 40px;
    // min-width: 75px;
    color: $primary;
  }
  .sch-content {
    flex: 1;
    // width: 1470px;
    // margin-top: 3px;
    line-height: 40px;
    &.fix-height {
      height: 40px;
      overflow: hidden;
    }
  }
  .type-content {
    display: flex;
    min-width: 790px;
  }
  .sch-content span {
    // padding-right: 20px;
    padding: 0 15px;
    margin-right: 15px;
    height: 40px;
    box-sizing: border-box;
    color: $primary;
    display: inline-block;
    cursor: pointer;
    border: solid 1px transparent;
    &.blue {
      border: solid 1px #b29551;
    }
  }
  .switch {
    padding-right: 0 !important;
    color: $primary !important;
    position: absolute;
    right: 0;
    top: 14px;
  }
}
.sch-last {
  display: flex;
  font-size: 14px;
  padding-top: 10px;
  // background-color: #fff;
  .type-content {
    display: flex;
    min-width: 790px;
  }
  .sch-type {
    height: 20px;
    min-width: 75px;
    color: #9699a2;
    line-height: 40px;
  }
}
.sch-top {
  line-height: 24px;
  padding-bottom: 0;
  min-height: 44px;
  box-sizing: border-box;
}
.total-type {
  color: #9699a2;
  // margin-top: 3px;
  min-width: 75px;
}
// 多表联动 标签颜色
.tag {
  height: 24px;
  // width: 100%;
  line-height: 22px;
  border-radius: 12px;
  margin-right: 6px;
  // background-color: #fff;
  border-color: $primary;
}


.sort-box {
  margin-top: 30px;
  border-top: dashed 1px $primary;
  padding: 40px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  a {
    margin-right: 20px;
  }
}
</style>

